export enum StaffNoteType {
    Review = 'Review',
    Internal = 'Internal',
}
